import api from '../../lib/api';
import {
  url_api_v1_mk_delete,
  url_api_v1_mk_search,
  url_api_v1_mk_update,
} from '../../lib/apiUrl';

class MediaKitService {
  fetchMediaKits = async (filter: string, sortMode: string, pageParam: number, perPage: number, userId?: string) => {
    try {
      console.log('sb: fetchMediaKits In');
      let url = url_api_v1_mk_search;
      let filterUrl = '';

      // Add user_id parameter if provided
      if (userId) {
        filterUrl += (filterUrl === '' ? '?' : '&') + `user_id=${userId}`;
      }

      if (filter) {
        filterUrl += (filterUrl === '' ? '?' : '&') + filter;
      }
      if (pageParam >= 0) {
        filterUrl += (filterUrl === '' ? '?' : '&') + `page=${pageParam}`;
        filterUrl += `&per_page=${perPage}`;
      }
      if (sortMode && sortMode.length > 0) {
        filterUrl += (filterUrl === '' ? '?' : '&') + `sortMode=${sortMode}`;
      }
      const response = await api.get(url + filterUrl);
      if (response.status !== 200 && response.status !== 201) {
        throw new Error('Error while fetching media files.');
      }
      return response.data;
    } catch (error) {
      throw error;
    }
  };
  deleteMediaKitDocument = async (mk_uuid: any, kit_id: any, force: boolean = false) => {
    try {
      let url = url_api_v1_mk_delete.replace(':mk_id', mk_uuid).replace(':kit_id', kit_id);
      if (force) {
        url += '?force=true';
      }
      const response = await api.delete(url);
      if (response.status !== 200 && response.status !== 201) {
        throw new Error('Error: Item in use in Submission Kit.');
      }
      return response.data;
    } catch (error) {
      throw error;
    }
  };
  deleteCropMediaKitDocument = async (mk_uuid: any, kit_id: any) => {
    try {
      const url = url_api_v1_mk_delete.replace(':mk_id', mk_uuid).replace(':kit_id', kit_id);
      let filterUrl = '';
      filterUrl += (filterUrl == '' ? '?' : '&') + 'crop=1';
      const response = await api.delete(url + filterUrl);
      if (response.status !== 200 && response.status !== 201) {
        throw new Error('Error creating job.');
      }
      return true;
    } catch (error) {
      throw error;
    }
  };
  renameFileMediaKitDocument = async (mk_uuid: any, kit_id: any, fileName: string) => {
    try {
      const postData = {
        filename: fileName,
      };
      const url = url_api_v1_mk_update.replace(':mk_id', mk_uuid).replace(':kit_id', kit_id);
      const response = await api.put(url, postData);
      if (response.status !== 200 && response.status !== 201) {
        throw new Error('Error creating job.');
      }
      return true;
    } catch (error) {
      throw error;
    }
  };
  mediaBlogToAwsUrl = async (fileName: string) => {
    try {
      const response = await api.get(fileName, { maxRedirects: 0 });
      if (response.status !== 200 && response.status !== 201) {
        throw new Error('Error mediaBlogToAwsUrl.');
      }
      return response;
    } catch (error) {
      console.log(error);
      return null;
    }
  };
}

const mediaKitService = new MediaKitService();

export default mediaKitService;
